import { BaseMarkupProps } from "@custom-types/project-markups-types";
import { Box } from "@mui/material";
import { MarkupDueDate } from "@pages/project-details/project-markups/due-date/markup-due-date";
import { MarkupAssignee } from "@pages/project-details/project-markups/markup-assignee";
import { MarkupSidePanelInfoItem } from "@pages/project-details/project-markups/sidepanel";
import { MarkupDescription } from "@pages/project-details/project-markups/sidepanel/markup-description";
import { MarkupSidePanelTags } from "@pages/project-details/project-markups/sidepanel/markup-sidepanel-tags";
import { MarkupStatusDropdown } from "@pages/project-details/project-markups/status/markup-status-dropdown";
import { getCoordinateZUp } from "@utils/vector-utils";

/**
 * This component returns each item that will be inserted in the side panel
 */
export function MarkupsSidePanelInfo({ markup }: BaseMarkupProps): JSX.Element {
  /**
   * Get the markup in the same coordinate system as
   * displayed in the Sphere Viewer and Scene app
   */
  const markupPoseZUp = markup.globalPose
    ? getCoordinateZUp(markup.globalPose.pos)
    : null;

  return (
    <>
      <Box
        sx={{
          marginTop: "24px",
          display: "flex",
          flexDirection: "column",
          gap: "12px",
        }}
      >
        <MarkupSidePanelInfoItem
          title={"Sheet"}
          value={<var>{markup?.areaSection?.name || "-"}</var>}
        />
        <MarkupSidePanelInfoItem
          title="Scene"
          value={<var>{markup?.section?.name || "-"}</var>}
        />
        <MarkupSidePanelInfoItem
          title="Assignee"
          value={<MarkupAssignee markup={markup} isSidePanelOpen={true} />}
        />
        <MarkupSidePanelInfoItem
          title="Status"
          value={
            <MarkupStatusDropdown markup={markup} isSidePanelOpen={true} />
          }
        />
        <MarkupSidePanelInfoItem
          title="Due Date"
          value={<MarkupDueDate markup={markup} isSidePanelOpen={true} />}
        />
        <MarkupSidePanelInfoItem
          title="Global Pose"
          value={
            markupPoseZUp ? (
              <var>
                X: {markupPoseZUp.x.toLocaleString()}; Y:{" "}
                {markupPoseZUp.y.toLocaleString()}; Z:{" "}
                {markupPoseZUp.z.toLocaleString()}
              </var>
            ) : (
              "-"
            )
          }
        />
      </Box>

      {markup && <MarkupSidePanelTags labels={markup.labels} />}

      {markup && <MarkupDescription markup={markup} />}
    </>
  );
}
